import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { motion, AnimatePresence } from "framer-motion";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";

const boxRight = { 
  hidden: {
    x: 200,
    opacity: 0,
    transition: { 
      duration: 1
    }
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: "spring",
      bounce: 0.1,
      duration: 1.2
    }
  },
  exit: {
    x: 200,
    opacity: 0,
    transition: { 
      duration: 0.8
    }
  }
};


const LateralPopUp = ({ onClose })  => {
  const [isVisible, setIsVisible] = useState(true);
  const [isClosed, setIsClosed] = useState(false);

const { t } = useTranslation();

  const handleClose = () => {
    setIsVisible(false);
    setIsClosed(true); 
    onClose(true);
  };

  return (
          <AnimatePresence>
            {isVisible && !isClosed && (
              <motion.div 
                className="boxonRight"
                initial="visible"
                animate="visible"
                exit="exit"
                variants={boxRight}
              >
                  <div className="box-header-pop-up">
                    <button 
                      className="position-absolute close-button-white top-0 end-0 mt-3 me-3"
                      onClick={handleClose}
                    >
                      <FontAwesomeIcon className="text-white" icon={faTimes}/>
                    </button>
                    <div className="input-group ms-2">
                      <h3 className="text-white text-uppercase title">{t("DiscoverOurConcierge")}</h3>
                      <div className="arrowEffectContainer">
                      <HashLink to={"#contact-travel-designer"} smooth className="text-white input-group-text nav-link ctaWidthMax115 ctaLink">
                        {t("TalkWithUs")} <FontAwesomeIcon className="paddingArrow effectArrow" icon={faArrowRight} />
                      </HashLink>
                      </div>

                    </div>
                  </div>
              </motion.div>
            )}
          </AnimatePresence>
  );
};

export default LateralPopUp;
